// extracted by mini-css-extract-plugin
export default {"form":"contactForm_form__c9LIM","text":"contactForm_text__AetPh","error":"contactForm_error__HWUk1","header":"contactForm_header__CaH7B","subheader":"contactForm_subheader__6uIhk"};